export enum FelloConnectOrigin {
  FC = "FC",
  CRMX = "CRMX",
  ENGAGE = "EN",
  ENRICH = "ENR",
  LP = "LP",
  WEB = "WEB", // Property Dashboard
  PURL = "PURL",
  REFERRAL = "REFERRAL",
  T = "T",
  WIDGET = "WGT",
  AUTOMATION = "AUTOMATION",
  WORKFLOW = "WORKFLOW",
  LEAD_MARKETPLACE = "LEAD_MARKETPLACE",

  POSTCARD = "POSTCARD",
  FCM = "FCM" // Manual
}

export const FelloConnectOriginLabel: Record<FelloConnectOrigin, string> = {
  [FelloConnectOrigin.FC]: "File Import",
  [FelloConnectOrigin.CRMX]: "Integration",
  [FelloConnectOrigin.ENGAGE]: "Engage",
  [FelloConnectOrigin.ENRICH]: "Enrich",
  [FelloConnectOrigin.LP]: "Landing Page",
  [FelloConnectOrigin.WEB]: "Contact Dashboard",
  [FelloConnectOrigin.PURL]: "Personalized URL",
  [FelloConnectOrigin.REFERRAL]: "Referral",
  [FelloConnectOrigin.T]: "Turbo",
  [FelloConnectOrigin.WIDGET]: "Widget",
  [FelloConnectOrigin.AUTOMATION]: "Automation",
  [FelloConnectOrigin.WORKFLOW]: "Workflow",
  [FelloConnectOrigin.LEAD_MARKETPLACE]: "Lead Marketplace",
  [FelloConnectOrigin.POSTCARD]: "Postcard",
  [FelloConnectOrigin.FCM]: "Manual"
};
